import useOpenApiClient from '@/hooks/useOpenApiClient';
import { toFixedTwo } from '@/lib/utils';
import { components } from '@/types/api';

type LineItem = components['schemas']['LineItem'];

export default function LineItemSummary({ lineItem }: { lineItem: LineItem | null }) {
  const { userRole } = useOpenApiClient();
  if (lineItem === null) {
    return null;
  }

  return (
    <div className="">
      <div className="space-y-2">
        <p className="text-[15px] font-bold">
          {+lineItem.total_benefit === 0 ? (
            <>You paid ${toFixedTwo(lineItem.line_total)} for this line item</>
          ) : (
            <>
              You paid ${toFixedTwo(lineItem.line_total)}, got back{' '}
              <span className="text-primary">${toFixedTwo(lineItem.total_benefit)}. </span>
              The revised amount for this item is ${toFixedTwo(lineItem.revised_amount)}
            </>
          )}
        </p>
        <span className="text-xs font-normal">
          {+lineItem.total_benefit === 0 && userRole !== 'live' ? (
            <>This line item is not eligible for enrichment</>
          ) : null}
        </span>
      </div>
    </div>
  );
}
